module.exports = __webpack_public_path__ + "static/media/filter_icon.f4edd2e5.png";